/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioCarpetaPersonalIdUserPatch$Params {
  idUser: string;
      body?: {
}
}

export function usuarioCarpetaPersonalIdUserPatch(http: HttpClient, rootUrl: string, params: UsuarioCarpetaPersonalIdUserPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioCarpetaPersonalIdUserPatch.PATH, 'patch');
  if (params) {
    rb.path('idUser', params.idUser, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioCarpetaPersonalIdUserPatch.PATH = '/usuario/carpeta-personal/{idUser}';
